import React, { useEffect, useRef } from "react";
import { Row } from "react-bootstrap";
import { workxpArray } from "./WorkXPArray.js";
import UnderConst from "../utils/UnderConst";
import WorkXPCard from "./WorkXPCard";

const WorkXP = (props) => {
  const myRef = useRef(null);

  useEffect(() => {
    if (props.sd === "workxp") {
      console.log(props.sd);
      myRef.current.scrollIntoView();
    }
  }, [props.sd]);

  return (
    <div
      ref={myRef}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1
        style={{
          color: "black",
          fontSize: "50px",
          fontWeight: "bold",
          color: "#155BDD",
          marginTop: "50px",
          fontFamily: "Tenorite",
        }}
      >
        WORK XP
      </h1>
      <br />
      {/* <UnderConst /> */}
      <br />
      <Row
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          marginBottom: "20px",
          marginTop: "20px",
        }}
      >
        {workxpArray.map((workxp) => (
          <div style={{width: "100%", display: "flex", padding: "0px", marginBottom: "20px"}}>
            <WorkXPCard 
              id={workxp.id}
              workImg={workxp.workImg}
              workTitle={workxp.workTitle}
              workCompany={workxp.workCompany}
              workDescrption={workxp.workDescrption}
            />
          </div>
        ))}
        
      </Row>
    </div>
  );
};

export default WorkXP;
